"use client";

import { usePathname, useRouter } from "@/i18n/routing";
import clsx from "clsx";
import { useTranslations } from "next-intl";
import { useCallback } from "react";

export default function MenuTitle() {
  const path = usePathname();
  const router = useRouter();
  const t = useTranslations();
  const title = useCallback(() => {
    // console.log(path);
    const segment = path.split("/").pop() || "Dashboard";
    // console.log(segment);

    if (/^\/games*/.test(path)) {
      return "Game List";
    }

    switch (path) {
      case "/profile":
        return t("profile");
      case "/vip":
        return t("vip-privileges");
      case "/profile/bank-details":
        return t("bank-details");
      case "/profile/edit":
        return t("edit-profile");
      case "/profile/change-password":
        return t("change-password");
      case "/profile/deposit":
        return t("IN");
      case "/profile/withdrawal":
        return t("OUT");
      case "/profile/deposit/bank-transfer":
        return t("bank-transfer");
      case "/profile/deposit/genkinpay":
        return t("genkinpay");
      case "/profile/deposit/genkinpay/completed":
        return t("deposit-request-completed");
      case "/profile/withdrawal":
        return t("withdrawal");
      case "/promotion":
        return t("promotion");
      case "/referral":
        return t("refer-and-earn");
      case "/wallet":
        return t("wallet");
      case "/wallet/wallet-history/cash":
        return t("cash-wallet-history");
      case "/wallet/wallet-history/rebate":
        return t("rebate-history");
      case "/wallet/wallet-history/referral":
        return t("referral-history");
      case "/wallet/wallet-history/loyalty-point":
        return t("loyalty-point-history");
      case "/wallet/wallet-history/bet-history":
        return t("bet-history");
      case "/profile/promo-code":
        return t("claim-promotion-by-code");
      case "/rewards":
        return t("rewards");
      case "/lp-store":
        return t("lp-store");
      default:
        return segment;
    }
  }, [path]);
  return (
    <div
      className={clsx("flex w-full items-center justify-start gap-4 bg-[#042226] px-4 py-3 text-center", {
        hidden: /^\/profile\/(withdrawal|deposit)/.test(path),
      })}
    >
      <button
        onClick={() => {
          if (/^\/games*/.test(path)) {
            router.push("/");
            return;
          }

          if (/^\/wallet/.test(path)) {
            if (/^\/wallet\/wallet-history*/.test(path)) {
              router.push("/wallet");
              return;
            }
            router.push("/");
            return;
          }

          if (/^\/profile/.test(path)) {
            if (/^\/profile\/bank-details/.test(path)) {
              router.push("/profile");
              return;
            }

            if (/^\/profile\/deposit*/.test(path) || /^\/profile\/withdrawal*/.test(path)) {
              router.push("/profile");
              return;
            }
            router.push("/");
            return;
          }
          router.back();
        }}
      >
        <span className="icon-icon6 text-2xl" />
      </button>
      <div className="text-base font-semibold">{title()}</div>
    </div>
  );
}
